import {
  UserRound,
  Car,
  ArrowBigDown,
  LifeBuoy,
  ArrowBigUp,
  ThumbsUp
} from "lucide-react";
import styles from "./Work.module.css";

const steps = [
  { icon: <UserRound />, title: "Omówienie potrzeb klienta" },
  { icon: <Car />, title: "Przyjęcie samochodu na warsztat" },
  { icon: <ArrowBigDown />, title: "Demontaż oraz diagnostyka opon i felg" },
  { icon: <LifeBuoy />, title: "Właściwa usługa" },
  { icon: <ArrowBigUp />, title: "Montaż oraz kontorla końcowa" },
  { icon: <ThumbsUp />, title: "Wydanie pojazdu" }
];

export default function Work() {
  return (
    <section className="darkSectionContent" id="work">
      <div className="lightSectionTitle">
        <h1>Etapy naszej pracy</h1>
      </div>
      <div className={styles.flow}>
        {steps.map((s, i) =>
          <div key={i} className={styles.item}>
            <div className={styles.icon}>
              {s.icon}
            </div>
            <p className={styles.workItem}>
              {s.title}
            </p>
            {i < steps.length - 1 && <div className={styles.line} />}
          </div>
        )}
      </div>
    </section>
  );
}